import script from "./SpecialReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialReportTable.vue?vue&type=script&setup=true&lang=js"

import "./SpecialReportTable.vue?vue&type=style&index=0&id=741d683b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741d683b"]])

export default __exports__